module.exports = __webpack_public_path__ + "img/s3rlt.5bc5becd.svg";